import { seasonsBest } from './recipes/seasonsBest.js';
export const dining = {
  id: '1-dining',
  name: 'Dining',
  levels: [
    {
      tileSize: 256,
      size: 256,
      fallbackOnly: true,
    },
    {
      tileSize: 512,
      size: 512,
    },
    {
      tileSize: 512,
      size: 1024,
    },
    {
      tileSize: 512,
      size: 2048,
    },
  ],
  faceSize: 2048,
  initialViewParameters: {
    yaw: -0.3843180451916126,
    pitch: 0.3526006713439589,
    fov: 1.4254872060750312,
  },
  linkHotspots: [
    {
      yaw: 2.3505075880864483,
      pitch: 0.4833249769754371,
      rotation: 10.995574287564278,
      target: '4-left',
    },
    {
      yaw: -2.9032481204218374,
      pitch: 0.23881598944240423,
      rotation: 0,
      target: '2-island',
    },
    {
      yaw: -2.542883060759305,
      pitch: 0.00030821770804401183,
      rotation: 16.493361431346422,
      target: '0-countertop',
    },
    {
      yaw: 2.7076829288418356,
      pitch: 0.020681135917602234,
      rotation: 21.991148575128566,
      target: '5-right',
    },
    {
      yaw: 3.1209828619197673,
      pitch: -0.039765332063552705,
      rotation: 9.42477796076938,
      target: '3-range',
    },
  ],
  infoHotspots: [
    {
      yaw: -0.858370772242024,
      pitch: 0.13924238682561985,
      title: `Season’s Best®`,
      subhead: 'Season’s Best® (Fall/Winter 2021)',
      text: `
<ul>
    <li> <span class="b">#100699</span></li>
    <li> <span class="b">USD</span> $2 | <span class="b">CAD</span> $3</li>
    <li> Twice each year we create a Season's Best collection that showcases some of our favorite seasonal flavors. We're especially proud of this season's collection because it includes recommendations of how each recipe can fit into your busy, complicated life! Including: 30 minutes or less, better than takeout, budget friendly, easy cleanup, from the pantry, picky eaters, and quick prep.</li>
    <li> Get 15 recipes that'll shake up your menu with simple flavor twists, timesaving techniques, and quick tips.</li>
    <li> <span class="title">Sides & Apps</span><br/><br/>Veggie and Ricotta Flatbread <br/>Turmeric & Coconut-Braised Chickpeas <br/>Cauliflower au Gratin</li>
    <li> <span class="title">Mains</span><br/><br/>
    Chicken Divan
    <br/>Shrimp Teriyaki <br/>Burrito Cups <br/>Broccoli-Cheddar Burgers <br/>One-Pot Chicken & Gnocchi <br/>Rigatoni With Roasted Tomato Vodka Sauce <br/>Fried Chicken Sandwich <br/>Vegan Black Bean Soup <br/>Butter Chicken</li>
    <li><span class="title">Desserts</span><br/><br>Air Fryer Beignets<br/> Morning Glory Muffins <br/> Apple Torte</li>
</ul>
        `,
      images: [
        { id: `j9f1m0geyw`, key: `nc1-gs1-27` },
        { id: `elrx5p5cii`, key: `nc1-gs1-28` },
        { id: `tx88ndtgkw`, key: `nc1-gs1-29` },
        { id: `wpmn6aujk8`, key: `nc1-gs1-30` },
        { id: `maspndof7w`, key: `nc1-gs1-31` },
      ],
      recipes: seasonsBest.recipes,
    },
    {
      yaw: -0.10074843333351247,
      pitch: 0.3750695859132058,
      title: 'Get More Out of Mealtime',
      fullwidth: true,
      text: `
    <iframe src="https://pamperedchef.widen.net/view/pdf/inilysddiq/flyer-nck-fall-2021-us-ca-table.pdf?t.download=true&u=cfitwu" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
`,
    },
    {
      yaw: 0.9113818380380181,
      pitch: 0.2052711809335932,
      fullwidth: true,
      title: 'Host a Party. Get Rewards.',
      text: `<iframe src="https://pamperedchef.widen.net/view/pdf/s2gapztgcj/flyer-table-host-rewards-fall-2021-usca.pdf?t.download=true&u=intbhg" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>`,
    },
  ],
};
